const keys = {
    GET_CHATBOTS_HISTORY: (id: string) => `/chat-bots-history/${id}`,
    GET_CHATBOTS_STORY_HISTORY: (id: string) => `/chat-bots-history/story/${id}`,
    POST_CHATBOTS_MSG: (id: string) => `/chat-bots/${id}`,
    POST_CHATBOTS_STORY_MSG: (id: string) => `/chat-bots/story/${id}`,
    GET_CHATBOTS_CONTENT: (pageID: number, chatId: string) => `/get-chat-history-content/${pageID}/${chatId}`
};

export default keys;

